import { createFileRoute, redirect } from "@tanstack/react-router";
import { queryClient } from "../lib/queryClient";
import { meQuery, type Me } from "../hooks/useAuth";
import { hasPermission } from "../hooks/useCan";

export const Route = createFileRoute("/_auth/")({
  beforeLoad: () => {
    // Today is a bookings screen. A trainer can't read bookings, so their
    // home is their own training calendar instead.
    const me = queryClient.getQueryData<Me>(meQuery.queryKey);
    if (me && !hasPermission(me, "view_bookings") && hasPermission(me, "view_training")) {
      throw redirect({ to: "/trainers" });
    }
    // A therapist sees only their own bookings: their calendar is home.
    if (me && hasPermission(me, "view_bookings") && !hasPermission(me, "view_all_bookings")) {
      throw redirect({ to: "/calendar" });
    }
    throw redirect({ to: "/today" });
  },
});
